export default __webpack_public_path__ + "static/media/org_contact_name.47019126.svg";